import React, { useCallback, useEffect, useState } from 'react';
import { EuiForm } from '@elastic/eui';
import ButtonGroup from '../../../components/Form/ButtonGroup';
import FormGroupDescription from '../../../components/formGroupDescription';
import { useDispatch, useSelector } from 'react-redux';
import { restaurantSettingsAPI } from '../../../api/restaurantSettings/restaurantSettingsAPI';
import useFormActionsHandler from '../../../hooks/useFormActionsHandler';

const LoginRestrictions = (props) => {
    const { restaurantResponse, fetchRestaurant } = props;
    const dispatch = useDispatch();
    const restaurantDescriptions = useSelector((state) => state.auth.restaurantDescriptions);

    const [defaultValues, setDefaultValues] = useState({});

    const updateFormValues = useCallback((data) => {
        let defaultValue = {};
        defaultValue.enforce_single_device_login = data?.settings?.enforce_single_device_login ?? 0;
        return defaultValue;
    }, []);

    useEffect(() => {
        setDefaultValues(updateFormValues(restaurantResponse.restaurant));
    }, [restaurantResponse.restaurant, updateFormValues]);

    const onFormSaveApi = useCallback(
        async (data) => {
            const response = await dispatch(restaurantSettingsAPI('login_restrictions', data));
            if (response.success) {
                fetchRestaurant();
            } else {
                alert(response.message);
            }

            if (response.success) setDefaultValues(updateFormValues(response.restaurant));
            return response;
        },
        [dispatch, fetchRestaurant, updateFormValues]
    );

    const { errors, control, watch, setValue } = useFormActionsHandler({ onFormSaveApi, defaultValues });

    return (
        <>
            <EuiForm component='form'>
                <FormGroupDescription
                    title={restaurantDescriptions?.enforce_single_device_login?.display_name || 'Enforce Single Device Login'}
                    description={
                        restaurantDescriptions?.enforce_single_device_login?.description ||
                        'When enabled, customers can only be logged in on one device at a time.'
                    }
                >
                    <ButtonGroup
                        idSelected={watch('enforce_single_device_login') ? '1' : '0'}
                        color='primary'
                        control={control}
                        setValue={setValue}
                        name='enforce_single_device_login'
                        watch={watch}
                        legend='Enforce single device login'
                    />
                </FormGroupDescription>
            </EuiForm>
        </>
    );
};

export default React.memo(LoginRestrictions);
